import PropTypes from "prop-types";
import React, { useState } from "react";

const CustomAccordion = ({
  title,
  children,
  defaultOpen = false,
  className = "",
  classNameIcon = "",
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div
      className={`w-full rounded-lg border ${className} ${disabled ? " cursor-not-allowed" : ""}`}
    >
      <button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (!disabled) setIsOpen(!isOpen);
        }}
        className={`flex w-full items-center justify-between px-2 bg-white hover:bg-gray-50 ${
          disabled ? "bg-gray-400 text-gray-800" : ""
        }`}
        disabled={disabled}
        tabIndex={disabled ? -1 : 0}
        aria-disabled={disabled}
      >
        <span className="font-medium">{title}</span>
        {!disabled && (
          <svg
            className={`h-[18px] w-[18px] transform transition-transform ${classNameIcon} ${
              isOpen ? "rotate-180" : ""
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        )}
      </button>
      {isOpen && !disabled && (
        <div className="px-2 pb-2 pt-1">{children}</div>
      )}
    </div>
  );
};

CustomAccordion.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node,
  defaultOpen: PropTypes.bool,
  className: PropTypes.string,
  classNameIcon: PropTypes.string,
  disabled: PropTypes.bool,
};

export default CustomAccordion;